module.exports = __webpack_public_path__ + "img/a-propos-prestations-1.b9c87485.webp";